// extracted by mini-css-extract-plugin
export var dividerLine = "_8s-3";
export var itemImage = "_8s-9";
export var lightDivider = "_8s-4";
export var modalContent = "_8s-5";
export var modalContentCompact = "_8s-6";
export var productCard = "_8s-a";
export var productImage = "_8s-b";
export var productImageCompact = "_8s-7";
export var productImagePlaceholder = "_8s-c";
export var productImagePlaceholderCompact = "_8s-8";
export var progressBarBackground = "_8s-1";
export var progressBarContainer = "_8s-0";
export var progressBarFill = "_8s-2";